export default {
  app: {
    sidebarTransitionTime: 300, // ms
    colors: {
      sidebar: '#002B49',
      navbar: '#ffffff',
      primary: '#005792',
      secondary: '#798892',
      success: '#21AE8C',
      info: '#1A86D0',
      warning: '#FDA700',
      danger: '#FD5F00',
      inverse: '#002B49',
      textColor: '#495057',
      gray: '#D7DFE6'
    },
    chartColors: {
      axisColor: '#8EA1AB'
    }
  },
  defines: {
    component: {
      buttonDefaultData: [
        { code: '0', name: '오늘' },
        { code: '1', name: '1개월' },
        { code: '3', name: '3개월' },
        { code: '6', name: '6개월' },
        { code: '12', name: '12개월' },
        { code: '99', name: '전체' }
      ]
    },
    commons: {
      hourData: [
        { id: 0, code: '00', name: '00' },
        { id: 1, code: '01', name: '01' },
        { id: 2, code: '02', name: '02' },
        { id: 3, code: '03', name: '03' },
        { id: 4, code: '04', name: '04' },
        { id: 5, code: '05', name: '05' },
        { id: 6, code: '06', name: '06' },
        { id: 7, code: '07', name: '07' },
        { id: 8, code: '08', name: '08' },
        { id: 9, code: '09', name: '09' },
        { id: 10, code: '10', name: '10' },
        { id: 11, code: '11', name: '11' },
        { id: 12, code: '12', name: '12' },
        { id: 13, code: '13', name: '13' },
        { id: 14, code: '14', name: '14' },
        { id: 15, code: '15', name: '15' },
        { id: 16, code: '16', name: '16' },
        { id: 17, code: '17', name: '17' },
        { id: 18, code: '18', name: '18' },
        { id: 19, code: '19', name: '19' },
        { id: 20, code: '20', name: '20' },
        { id: 21, code: '21', name: '21' },
        { id: 22, code: '22', name: '22' },
        { id: 23, code: '23', name: '23' }
      ],
      userAgreeData: [
        { id: 1, code: true, name: '동의' },
        { id: 2, code: false, name: '탈퇴(미가입)' }
      ],
      userLetterAgreeData: [
        { id: 1, code: true, name: '동의' },
        { id: 2, code: false, name: '미동의' }
      ],
      useData: [
        { id: 1, code: '0', name: '미사용' },
        { id: 2, code: '1', name: '사용' }
      ],
      activeData: [
        { id: 1, code: '1', name: '활성' },
        { id: 2, code: '0', name: '비활성' }
      ],
      visibleData: [
        { id: 1, code: '1', name: '노출' },
        { id: 2, code: '0', name: '미노출' }
      ],
      monthData: [
        { id: 1, code: 1, name: '1월' },
        { id: 2, code: 2, name: '2월' },
        { id: 3, code: 3, name: '3월' },
        { id: 4, code: 4, name: '4월' },
        { id: 5, code: 5, name: '5월' },
        { id: 6, code: 6, name: '6월' },
        { id: 7, code: 7, name: '7월' },
        { id: 8, code: 8, name: '8월' },
        { id: 9, code: 9, name: '9월' },
        { id: 10, code: 10, name: '10월' },
        { id: 11, code: 11, name: '11월' },
        { id: 12, code: 12  , name: '12월' },
      ]
    },
    penalty: {
      historyTypeData: [
        { id: 1, code: 'mailing', name: '상품 메일 발송' },
        { id: 2, code: 'manualPenalty', name: '상품 수동 점수부여' },
        { id: 3, code: 'salesStop', name: '어드민 상품 중지' },
        { id: 4, code: '', name: '파트너사 판매 중지' },
        { id: 5, code: '', name: '파트너사 판매 중지 메일' }
      ],
      penaltyStatusTypeData: [
        { id: 1, code: 'NORMAL', name: '정상' },
        { id: 2, code: 'CAUTION', name: '주의' },
        { id: 3, code: 'WARN', name: '경고' },
        { id: 4, code: 'EMPTY', name: '상태 없음' }
      ],
      saleStatusTypeData: [
        { id: 1, code: 'ONSALE', name: '판매중' },
        { id: 2, code: 'STOP', name: '판매중지' }
      ],
      mailingStatusData: [
        { id: 1, code: 'SENT', name: '발송' },
        { id: 2, code: 'UNSENT', name: '미발송' }
      ],
      penaltyPartnerStatusTypeData: [
        { id: 1, code: 'CAUTION', name: '주의' },
        { id: 2, code: 'WARN', name: '경고' }
      ],
      penaltyReasonTypeData: [
        { id: 1, code: 'CS_UNFAIR', name: 'CS 부당 처리' },
        { id: 2, code: 'CS_UNKIND', name: 'CS 응대 불친절' },
        { id: 3, code: 'CS_AVOID', name: 'CS 응답 회피' },
        { id: 4, code: 'INVOICE_FAKE', name: '가송장' },
        { id: 5, code: 'POOR_INVENTORY_MANAGEMENT', name: '재고 관리 미흡' }
      ],
      stopReasonTypeData: [
        { id: 1, code: 'DELAYED_DELIVERY_RELEASE', name: '전체 주문에 대한 평균적인 배송 지연', availableType: ['Product', 'Company'] },
        { id: 2, code: 'DELAYED_CLAIM_ACCEPT', name: '전체 주문에 대한 평균적인 클레임 처리 지연', availableType: ['Product', 'Company'] },
        { id: 3, code: 'DELAYED_INQUIRY_REPLY', name: '전체 상품에 등록된 Q&A 응답 지연', availableType: ['Product', 'Company'] },
        { id: 4, code: 'CS_AVOID', name: 'CS 응답 회피', availableType: ['Product', 'Company'] },
        { id: 5, code: 'CS_UNKIND', name: 'CS 응대 불친절', availableType: ['Product', 'Company'] },
        { id: 6, code: 'CS_UNFAIR', name: 'CS 부당 처리', availableType: ['Product', 'Company'] },
        { id: 7, code: 'INVOICE_FAKE', name: '가송장', availableType: ['Product', 'Company'] },
        { id: 8, code: 'POOR_INVENTORY_MANAGEMENT', name: '재고 관리 미흡', availableType: ['Product', 'Company'] },
        { id: 9, code: 'LOW_REVIEW_SCORE', name: '리뷰 점수 4.0 미만', availableType: ['Product'] }
      ],
      memoProductReasonTypeData: [
        { id: 1, code: 'MAIL_PENALTY', name: '상품 메일 발송 (주의,경고)' },
        { id: 2, code: 'PENALTY_MANUAL', name: '상품 수동 점수 부여' },
        { id: 3, code: 'MAIL_PRODUCT_SALE_STOP', name: '상품 메일 발송 (상품 판매중지)' },
        { id: 4, code: 'PRODUCT_SALE_STOP', name: '상품 판매중지' }
      ],
      memoPartnerReasonTypeData: [
        { id: 1, code: 'MAIL_PARTNER_STOP', name: '파트너사 메일 발송 (판매중지)' },
        { id: 2, code: 'PARTNER_STOP', name: '파트너사 판매중지' }
      ],
      productQueryTargetData: [
        { id: 0, code: 'ALL', name: '전체' },
        { id: 1, code: 'productNo', name: '상품번호' },
        { id: 2, code: 'productName', name: '상품명' }
      ]
    },
    serviceComplaint: {
      productStatusData: [
        { id: 1, code: 'ISSUE', name: '위험' },
        { id: 2, code: 'NORMAL', name: '정상' },
        { id: 3, code: 'GREAT', name: '우수' }
      ],
      productQueryTargetData: [
        { id: 0, code: 'ALL', name: '전체' },
        { id: 1, code: 'productNo', name: '상품번호' },
        { id: 2, code: 'productName', name: '상품명' }
      ]
    },
    partner: {
      gradeData: [
        { id: 1, code: 'GOOD', name: '우수 파트너사' },
        { id: 2, code: 'NORMAL', name: '파트너사' }
      ]
    }
  },

  // API 엔드포인트
  clickRewardApiBaseUrl: 'https://ads-dev.tdeal.kr/admin/api/',
}
